import { GAME_MODES } from './constants/modes';
import TABLE_DATA, { columnNames, maximumCellValue } from './constants/table';
import DICE_DATA from './constants/diceData';

export const numberOfInitialRolls = 3;
export const diceInitialState = [DICE_DATA, DICE_DATA, DICE_DATA, DICE_DATA, DICE_DATA, DICE_DATA];
export const initialTableData = (gameMode) => {
	let columns = [];

	if ([GAME_MODES.COLUMNS_4, GAME_MODES.COLUMNS_6, GAME_MODES.COLUMNS_8, GAME_MODES.COLUMNS_10].indexOf(gameMode) !== -1) {
		columns = TABLE_DATA.columns.slice(0, gameMode);
	}

	if (GAME_MODES.ANNOUNCE_AND_COMMAND === gameMode) {
		columns = [columnNames.ANNOUNCE, columnNames.FREE, columnNames.COMMAND];
	}

	if (GAME_MODES.HANDS === gameMode) {
		columns = [columnNames.HAND, columnNames.HAND, columnNames.HAND, columnNames.HAND];
	}

	if (GAME_MODES.FREE === gameMode) {
		columns = [columnNames.FREE, columnNames.FREE, columnNames.FREE, columnNames.FREE];
	}

	return columns.map((column, i) => ({
		name: column,
		id: `${column}${i}`,
		isActive: true,
		cells: TABLE_DATA.cells.map(cell => ({
			...TABLE_DATA.cellObject,
			name: cell,
			maximumValue: maximumCellValue(cell),
		})),
	}));
};
